(function () {
  'use strict';
  var PRODUCT_ID = '8199564165411';
  function parse(value) { try { return JSON.parse(value); } catch (_) { return null; } }
  function initialize() {
    if (!window.CarOptionsVWRadioWizard) return;
    Array.from(document.querySelectorAll('[data-product-featured]')).forEach(function (feature) {
      var metadata = parse(feature.getAttribute('data-product-featured'));
      if (!metadata || String(metadata.id) !== PRODUCT_ID || metadata.isMainProduct !== true || feature.__coVwRadioWizard) return;
      var host = feature.querySelector('[data-co-vw-radio-wizard-host]');
      var configNode = feature.querySelector('[data-co-vw-radio-wizard-config]');
      var config = configNode && parse(configNode.textContent);
      var form = metadata.formID && feature.querySelector(metadata.formID);
      if (!host || !config || String(config.productId) !== PRODUCT_ID || !form) return;
      var selector = form.querySelector('[name="id"]');
      var activeVariant = selector ? String(selector.value) : '';
      var lastFormValue = activeVariant;
      function getVariantId() {
        var current = form.querySelector('[name="id"]');
        var value = current ? String(current.value) : '';
        if (value !== lastFormValue) { lastFormValue = value; activeVariant = value; }
        return activeVariant;
      }
      var instance = window.CarOptionsVWRadioWizard.mount({root: host, config: config, getVariantId: getVariantId});
      feature.__coVwRadioWizard = instance;
      var fallback = feature.querySelector('[data-co-vw-radio-wizard-fallback]');
      if (fallback) fallback.hidden = true;
      host.style.width = '100%';
      host.style.flexBasis = '100%';
      function place() {
        var menu = form.querySelector('[data-element-id="switch-2"]');
        var anchor = form.querySelector('[data-element-id="heading-2"]') || menu;
        if (anchor && anchor.parentNode && host.nextElementSibling !== anchor) anchor.parentNode.insertBefore(host, anchor);
        else if (!anchor) {
          var swatches = form.querySelector('.t4s-swatch');
          if (swatches && swatches.nextElementSibling !== host) swatches.insertAdjacentElement('afterend', host);
        }
      }
      function nativeChange(event) {
        if (event.target && event.target.name === 'id') {
          activeVariant = String(event.target.value || ''); lastFormValue = activeVariant;
          instance.syncVariant();
        }
      }
      form.addEventListener('change', nativeChange);
      var jq = window.jQuery_T4NT;
      if (typeof jq === 'function') jq(feature).on('variant:changed.coVwRadioWizard', function (event) {
        if (event.currentVariant) activeVariant = String(event.currentVariant.id || '');
        var current = form.querySelector('[name="id"]');
        lastFormValue = current ? String(current.value) : '';
        instance.syncVariant();
      });
      var observer = new MutationObserver(place);
      observer.observe(form, {childList: true, subtree: true});
      place();
      function unload(event) {
        if (!event.target || !event.target.contains(feature)) return;
        observer.disconnect(); form.removeEventListener('change', nativeChange);
        if (typeof jq === 'function' && typeof jq(feature).off === 'function') jq(feature).off('.coVwRadioWizard');
        instance.destroy(); delete feature.__coVwRadioWizard;
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
}());
